import { reactShell } from './config';

const { cognito } = reactShell;

export async function getCognitoToken() {
    try {
        const session = await cognito.fetchAuthSession();
        if (!session.userSub) return null;

        const accessTokenJwt = session.tokens!.accessToken;
        return accessTokenJwt;
    } catch (err) {
        return null;
    }
}
